















import {Component, Prop, Vue} from "vue-property-decorator";

import CellChooser from "@/views/Dropups/views/CellChooser.vue";
import {CELL_SIZES} from "@/constants/orders";

@Component({
    name: "CellChooserWrapper",
    components: {
      CellChooser,
    },
  })
  export default class CellChooserWrapper extends Vue {
    @Prop()
    private dropupPage!: object;

    @Prop()
    private lastSize!: CELL_SIZES;

    private currentCellSize: CELL_SIZES = CELL_SIZES.UNDEFINED_SIZE;

    private get returnProperSize() {
      return this.lastSize === CELL_SIZES.UNDEFINED_SIZE ? CELL_SIZES.SIZE_ID_SMALL : this.lastSize;
    }

    private updateCellSize(newCellSize: CELL_SIZES) {
      this.currentCellSize = newCellSize;
    }

    private next() {
      this.$emit("cellChooser:update", this.currentCellSize);
      this.$emit("cellChooser:next");
    }
  }
